import { Device, until } from '@helpers/media';
import { useInView } from '@hooks/useInView';
import useMedia from '@hooks/useMedia';
import Button from '@stories/Elements/Forms/Buttons/Button';
// import Image from '@stories/Elements/Media/Image/Image';
import LazyImage from '@stories/Elements/Media/LazyImage/LazyImage';
import ImageTransform from '@tti/image-transform';
import React, { FunctionComponent } from 'react';
import { TradeCardStyles } from './TradeCard.styles';

export interface TradeCardModel {
  id: string;
  imageUrl: string;
  iconUrl: string;
  text: string;
  buttonText: string;
  url: string;
}

export interface TradeCardProps {
  trade: TradeCardModel;
  index?: number;
  imageSizes?: string;
  rowItems?: number;
}

const TradeCard: FunctionComponent<TradeCardProps> = ({
  trade,
  index = 0,
  // imageSizes = `${from(600)} 50vw, ${from(Device.TabletLarge)} 342px, 100vw`,
  rowItems = useMedia([until(Device.MobileLarge), until(Device.DesktopSmall)], [2, 3], 4),
}) => {
  const [cardRef, cardInView] = useInView<HTMLAnchorElement>({ threshold: 0.15 });

  const baseDelay = 0;
  const indexDelay = index % rowItems;
  const delayInterval = baseDelay + indexDelay * 100;

  return (
    <TradeCardStyles.Card href={trade.url} key={trade.id} ref={cardRef} cardInView={cardInView} delay={delayInterval}>
      <TradeCardStyles.ImageWrapper>
        <LazyImage disableBlur={true} width={345} height={500} src={trade.imageUrl} alt={trade.text} />
      </TradeCardStyles.ImageWrapper>

      <TradeCardStyles.Overlay>
        <TradeCardStyles.Icon
          src={new ImageTransform(trade.iconUrl).entropyCrop().url}
          alt={trade.text}
          loading="lazy"
        />
        <TradeCardStyles.Text>{trade.text}</TradeCardStyles.Text>
        <TradeCardStyles.Button>
          <Button text={trade.buttonText} size="small" fakeButton={true} />
        </TradeCardStyles.Button>
      </TradeCardStyles.Overlay>
    </TradeCardStyles.Card>
  );
};

export default TradeCard;
